// docxToLexical.js
import JSZip from "jszip";
import { MathMLToLaTeX } from "mathml-to-latex";
// NOTE: some bundlers expose default, some named. Adjust if needed.
import omml2mathml from "omml2mathml";

const W = "http://schemas.openxmlformats.org/wordprocessingml/2006/main";
const R = "http://schemas.openxmlformats.org/officeDocument/2006/relationships";
const M = "http://schemas.openxmlformats.org/officeDocument/2006/math";

const QUESTION_TAG = "QUESTION_PAPERE";
const ANSWER_TAG = "ANSWER_PAPERE";
const CORRECT_ANSWER_TAG = "ANSWER_CORRECT_PAPERE";
const CORRECT_ANSWER_TAG_NUMBER = "ANSWER_CORRECT_NUMBER_PAPERE";

function parseXml(s) {
  return new DOMParser().parseFromString(s, "application/xml");
}
function q(node, ns, name) {
  return Array.from(node.getElementsByTagNameNS(ns, name));
}
function serialize(node) {
  return new XMLSerializer().serializeToString(node);
}
function textFromRun(runEl) {
  // Concatenate all w:t within this run
  return q(runEl, W, "t").map(t => t.textContent || "").join("");
}

const isEl = n => n && n.nodeType === 1;

// ---- Lexical JSON builders (keep simple) ----
function makeRoot(children) {
  return {
    root: {
      type: "root",
      version: 1,
      format: "",
      indent: 0,
      direction: "ltr",
      children
    }
  };
}

// function makeParagraph(childrenOrText) {
//   const children = Array.isArray(childrenOrText)
//     ? childrenOrText
//     : [makeTextNode(childrenOrText)];
//   return {
//     type: "paragraph",
//     version: 1,
//     format: "",
//     indent: 0,
//     direction: "ltr",
//     children
//   };
// }

function makeTextNode(text) {
  return {
    type: "text",
    version: 1,
    detail: 0,
    format: 0,
    mode: "normal",
    style: "",
    text
  };
}

// function makeImageNode(src, altText = "", width = 0, height = 0) {
//   // Matches our custom ImageNode (see nodes/ImageNode.js)
//   return { type: "image", version: 1, src, altText, width, height };
// }

function makeEquationNode(latex, inline) {
  // Matches our custom EquationNode (see nodes/EquationNode.js)
  return { type: "equation", version: 1, latex, inline: !!inline };
}

async function buildRels(zip, relsPath) {
  const file = zip.file(relsPath);
  if (!file) return {};
  const relsDoc = parseXml(await file.async("text"));
  const map = {};
  for (const rel of Array.from(relsDoc.getElementsByTagName("Relationship"))) {
    const id = rel.getAttribute("Id");
    const target = rel.getAttribute("Target");
    if (id && target) map[id] = target;
  }
  return map;
}

// ---------- Numbering (ordered list) discovery ----------
/**
 * Builds a set of keys `${numId}|${ilvl}` that are "ordered" levels.
 * Ordered = any number format not 'bullet' or 'none'.
 */
// function buildOrderedLevelSet(numberingDoc) {
//   const ordered = new Set();
//   if (!numberingDoc) return ordered;

//   // Map abstractNumId -> { ilvl -> numFmtVal }
//   const abstractMap = new Map();
//   for (const abs of getElsNS(numberingDoc, W, "abstractNum")) {
//     const absId = abs.getAttributeNS(W, "abstractNumId");
//     const lvlMap = new Map();
//     for (const lvl of getElsNS(abs, W, "lvl")) {
//       const ilvl = lvl.getAttributeNS(W, "ilvl") ?? "0";
//       const numFmt = firstChildNS(lvl, W, "numFmt");
//       const fmtVal = numFmt?.getAttributeNS(W, "val") ?? "decimal";
//       lvlMap.set(ilvl, fmtVal);
//     }
//     abstractMap.set(absId, lvlMap);
//   }

//   // For each concrete <w:num numId>, link to its abstract and mark ordered levels
//   for (const num of getElsNS(numberingDoc, W, "num")) {
//     const numId = num.getAttributeNS(W, "numId");
//     const absEl = firstChildNS(num, W, "abstractNumId");
//     const absId = absEl?.getAttributeNS(W, "val");
//     if (!numId || !absId) continue;

//     const lvlMap = abstractMap.get(absId);
//     if (!lvlMap) continue;
//     for (const [ilvl, fmt] of lvlMap.entries()) {
//       const f = (fmt || "").toLowerCase();
//       if (f !== "bullet" && f !== "none") {
//         ordered.add(`${numId}|${ilvl}`);
//       }
//     }
//   }
//   return ordered;
// }

function firstChildNS(parent, ns, local) {
  for (const n of parent.childNodes) {
    if (n.nodeType === 1 && n.namespaceURI === ns && n.localName === local) return n;
  }
  return null;
}

function getElsNS(node, ns, local) {
  return Array.from(node.getElementsByTagNameNS(ns, local));
}

function paragraphText(p) {
  return getElsNS(p, W, "t").map(t => t.textContent).join("").trim();
}

/**
 * Extract ordered list items (text + level) from a document XML.
 * Uses the orderedSet `${numId}|${ilvl}` to decide if a paragraph is an ordered list item.
 */
// function extractOrderedItemsFromXml(orderedSet, p) {
//   // const paras = getElsNS(docXml, W, "p");
//   const out = [];
//   // for (const p of paras) {
//     const pPr = firstChildNS(p, W, "pPr");
//     if (!pPr) return null;

//     const numPr = firstChildNS(pPr, W, "numPr");
//     if (!numPr) return null;

//     const numIdEl = firstChildNS(numPr, W, "numId");
//     if (!numIdEl) return null;
//     const numId = numIdEl.getAttributeNS(W, "val");
//     if (!numId) return null;

//     const ilvlEl = firstChildNS(numPr, W, "ilvl");
//     const ilvl = ilvlEl?.getAttributeNS(W, "val") ?? "0";

//     if (orderedSet.has(`${numId}|${ilvl}`)) {
//       const text = paragraphText(p);
//       if (text) out.push({ text, level: parseInt(ilvl, 10) || 0 });
//       if(text){
//         console.log({text})
//       }
//     }
//   // }
//   return out;
// }

// Extract inline content of a Word paragraph (text + inline math).
// function buildParagraphChildrenFromP(pEl) {
//   const children = [];
//   // Follow the child order: runs (w:r), inline equations (m:oMath), etc.
//   // Most inline math is wrapped under runs, but OMML allows direct nodes too.
//   for (const node of Array.from(pEl.childNodes)) {
//     console.log(node)
//     if (node.nodeType !== 1) continue;

//     // Block-ish OMML inside p: treat as block below; skip here.
//     if (node.namespaceURI === M && node.localName === "oMathPara") {
//       continue;
//     }

//     if (node.namespaceURI === M && node.localName === "oMath") {
//       // Inline equation
//       const omml = serialize(node);
//       const mathml = omml2mathml(omml);
      
//       if(mathml){
//         console.log({mathml})
//         const latex = MathMLToLaTeX.convert(mathml);
//         console.log({latex})
//         children.push(makeEquationNode(latex, true));
//       }
//       continue;
//     }

//     if (node.namespaceURI === W && node.localName === "r") {
//       // Run: may contain text, drawing, or OMML
//       const run = node;

//       // Inline OMML inside run?
//       const inlineMath = q(run, M, "oMath");
//       if (inlineMath.length) {
//         for (const m of inlineMath) {
//           const omml = serialize(m);
//           const mathml = omml2mathml(omml);
//           const latex = MathMLToLaTeX.convert(mathml);
//           children.push(makeEquationNode(latex, true));
//         }
//         continue;
//       }

//       // Normal text in run
//       const str = textFromRun(run);
//       if (str) children.push(makeTextNode(str));
//       console.log({ str });
//       continue;
//     }
//   }

//   // Combine adjacent text nodes for neatness
//   const compact = [];
//   for (const c of children) {
//     const last = compact[compact.length - 1];
//     if (last && last.type === "text" && c.type === "text") {
//       last.text += c.text;
//     } else {
//       compact.push(c);
//     }
//   }
//   return compact;
// }

function findChildNS(parent, ns, local) {
  for (const n of parent.childNodes) {
    if (n.nodeType === 1 && n.namespaceURI === ns && n.localName === local) return n;
  }
  return null;
}

function getElementsNS(node, ns, local) {
  return Array.from(node.getElementsByTagNameNS(ns, local));
}

function findHeading1StyleIds(stylesDoc) {
  // Try to find the styleId(s) whose displayed name is "Heading 1"
  const ids = new Set();
  const styles = getElementsNS(stylesDoc, W, "style");
  for (const s of styles) {
    const type = s.getAttributeNS(W, "type");
    if (type !== "paragraph") continue;
    const nameEl = findChildNS(s, W, "name");
    const display = nameEl?.getAttributeNS(W, "val") || "";
    if (display.trim().toLowerCase() === "heading 1") {
      const styleId = s.getAttributeNS(W, "styleId");
      if (styleId) ids.add(styleId);
    }
  }
  // Fallbacks for common default ids
  if (ids.size === 0) {
    ids.add("Heading1");
    ids.add("heading1");
  }
  return ids;
}

function extractParagraphText(p) {
  const ts = getElementsNS(p, W, "t");
  // Some w:t preserve spaces via xml:space="preserve"; textContent keeps it.
  return ts.map(t => t.textContent).join("").trim();
}

// function extractGivenHText(p, headingStyleIds) {
//   // const paras = getElementsNS(docXml, W, "p");
//   // console.log(p)
//   // const results = [];
//   // for (const p of paras) {
//     const pPr = findChildNS(p, W, "pPr");
//     if (!pPr) return null;
//     const pStyle = findChildNS(pPr, W, "pStyle");
//     if (!pStyle) return null;
//     const val = pStyle.getAttributeNS(W, "val");
//     if (val && headingStyleIds.has(val)) {
//       const text = extractParagraphText(p);
//       if (text) return text;
//     }
//     return null;
//   // }
//   // return results;
// }

const convertToLatexCompatibleObject = pEl =>{
  const result = [];
  const children = [];
  for (const node of Array.from(pEl.childNodes)) {
    if (node.nodeType !== 1) continue;

    // Block-ish OMML inside p: treat as block below; skip here.
    if (node.namespaceURI === M && node.localName === "oMathPara") {
      continue;
    }

    if (node.namespaceURI === M && node.localName === "oMath") {
      // Inline equation
      // const omml = serialize(node);
      // console.log(omml)
      // const om = '<m:oMath xmlns:wpc="http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas" xmlns:mo="http://schemas.microsoft.com/office/mac/office/2008/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:wp14="http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing" xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing" xmlns:w10="urn:schemas-microsoft-com:office:word" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:wpg="http://schemas.microsoft.com/office/word/2010/wordprocessingGroup" xmlns:wpi="http://schemas.microsoft.com/office/word/2010/wordprocessingInk" xmlns:wne="http://schemas.microsoft.com/office/word/2006/wordml" xmlns:wps="http://schemas.microsoft.com/office/word/2010/wordprocessingShape"><m:f><m:fPr><m:ctrlPr><w:rPr><w:rFonts w:ascii="Cambria Math" w:hAnsi="Cambria Math"/><w:i/></w:rPr></m:ctrlPr></m:fPr><m:num><m:r><w:rPr><w:rFonts w:ascii="Cambria Math" w:hAnsi="Cambria Math"/></w:rPr><m:t>1</m:t></m:r></m:num><m:den><m:r><w:rPr><w:rFonts w:ascii="Cambria Math" w:hAnsi="Cambria Math"/></w:rPr><m:t>2</m:t></m:r></m:den></m:f></m:oMath>'
      // const om = '<m:oMath xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main"><m:f><m:fPr><m:ctrlPr><w:rPr><w:rFonts w:ascii="Iskoola Pota" w:cs="Iskoola Pota" w:eastAsia="Iskoola Pota" w:hAnsi="Iskoola Pota"/></w:rPr></m:ctrlPr></m:fPr><m:num><m:r><w:rPr><w:rFonts w:ascii="Iskoola Pota" w:cs="Iskoola Pota" w:eastAsia="Iskoola Pota" w:hAnsi="Iskoola Pota"/></w:rPr><m:t xml:space="preserve">45</m:t></m:r></m:num><m:den><m:r><w:rPr><w:rFonts w:ascii="Iskoola Pota" w:cs="Iskoola Pota" w:eastAsia="Iskoola Pota" w:hAnsi="Iskoola Pota"/></w:rPr><m:t xml:space="preserve">78</m:t></m:r></m:den></m:f></m:oMath>'
      // const doc = new DOMParser().parseFromString(om, "application/xml")
      const doc = new DOMParser().parseFromString(node.outerHTML, "application/xml")
      // const mathml = omml2mathml('<m:oMath xmlns:wpc="http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas" xmlns:mo="http://schemas.microsoft.com/office/mac/office/2008/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:wp14="http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing" xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing" xmlns:w10="urn:schemas-microsoft-com:office:word" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:wpg="http://schemas.microsoft.com/office/word/2010/wordprocessingGroup" xmlns:wpi="http://schemas.microsoft.com/office/word/2010/wordprocessingInk" xmlns:wne="http://schemas.microsoft.com/office/word/2006/wordml" xmlns:wps="http://schemas.microsoft.com/office/word/2010/wordprocessingShape"><m:f><m:fPr><m:ctrlPr><w:rPr><w:rFonts w:ascii="Cambria Math" w:hAnsi="Cambria Math"/><w:i/></w:rPr></m:ctrlPr></m:fPr><m:num><m:r><w:rPr><w:rFonts w:ascii="Cambria Math" w:hAnsi="Cambria Math"/></w:rPr><m:t>1</m:t></m:r></m:num><m:den><m:r><w:rPr><w:rFonts w:ascii="Cambria Math" w:hAnsi="Cambria Math"/></w:rPr><m:t>2</m:t></m:r></m:den></m:f></m:oMath>');
      // console.log({mathml})
      const math = omml2mathml(doc)

      // const newMathml = convertOmml2Math(omml);
      // console.log(newMathml)
      
      // if(mathml){
      //   console.log({mathml})
      //   const latex = MathMLToLaTeX.convert(mathml);
      //   console.log({latex})
      //   children.push(makeEquationNode(latex, true));
      // }

      if(math){
        const latex = MathMLToLaTeX.convert('<math>' + math.innerHTML + '</math>');
        // children.push(makeEquationNode(latex, true));
      }

      // if(newMathml){
      //   try{
      //     const objStr = JSON.stringify(newMathml);
      //     console.log(objStr)
      //   const latex = MathMLToLaTeX.convert(newMathml);
      //   console.log({latex})
      //   // children.push(makeEquationNode(latex, true));
      //   }catch(e){
      //     console.log(e)
      //   }
      // }
      continue;
    }

    if (node.namespaceURI === W && node.localName === "r") {
      // Run: may contain text, drawing, or OMML
      const run = node;

      // Inline OMML inside run?
      const inlineMath = q(run, M, "oMath");
      if (inlineMath.length) {
        for (const m of inlineMath) {
          const omml = serialize(m);
          const mathml = omml2mathml(omml);
          const latex = MathMLToLaTeX.convert(mathml);
          children.push(makeEquationNode(latex, true));
        }
        continue;
      }

      // Normal text in run
      const str = textFromRun(run);
      if (str) children.push(makeTextNode(str));
      continue;
    }
  }

  // Combine adjacent text nodes for neatness
  const compact = [];
  for (const c of children) {
    const last = compact[compact.length - 1];
    if (last && last.type === "text" && c.type === "text") {
      last.text += c.text;
    } else {
      compact.push(c);
    }
  }
  return compact;
}


export async function docxToLexicalState(file) {
  const zip = await JSZip.loadAsync(await file.arrayBuffer());
  const docXmlFile = zip.file("word/document.xml");
  if (!docXmlFile) throw new Error("word/document.xml not found (invalid DOCX?)");

  const docXml = parseXml(await docXmlFile.async("text"));
  const rels = await buildRels(zip, "word/_rels/document.xml.rels");

  const stylesEntry = zip.file("word/styles.xml");
  const [stylesXml] = await Promise.all([
        stylesEntry ? stylesEntry.async("text") : Promise.resolve(null),
      ]);

      const stylesDoc = stylesXml ? parseXml(stylesXml) : null;
      const headingIds = stylesDoc ? findHeading1StyleIds(stylesDoc) : new Set(["Heading1", "heading1"]);


  const body = q(docXml.documentElement, W, "body")[0];

  const rootChildren = [];

  // ordered lists (document)

  // Walk paragraphs in order; if you want tables later, handle w:tbl similarly.
  const allParas = q(body, W, "p");
  let i = 0;
  //find first i with h1 text "QUESTION"
  do{
    let hText = extractParagraphText(allParas[i++]);
    if(hText && hText.toLowerCase().trim() === QUESTION_TAG){
      break;
    }
  }while(i < allParas.length );

  if(i >= allParas.length) {
    return [];
  }

  const allQuestions = [];
  do {
    // const p = allParas[i];

    // //first check this a h1 paragraph with text QUESTION
    // const hText = extractGivenHText(p, headingIds);
    // if(!hText){ 
    //   continue;
    // }
    // if(!hText.toLowerCase().includes("question")){
    //   continue;
    // }

    //if so read till next paragraph wich contains text ANSWER with h2 heading style
    const questionParas = [];
    let currentParaText = extractParagraphText(allParas[i]);
    while(currentParaText.toLowerCase().trim() !== ANSWER_TAG && currentParaText.toLowerCase().trim() !== CORRECT_ANSWER_TAG){
      questionParas.push(allParas[i]);
      i++;
      // console.log("inside filling question ", i)
      if(i >= allParas.length) break;
      currentParaText = extractParagraphText(allParas[i]);
    }

    // console.log({currentParaText})
    // console.log("after filling question ", i)
    let currentAnswerIndex = -1;
    if(currentParaText.toLowerCase().trim() === CORRECT_ANSWER_TAG){
      currentAnswerIndex = 0;
    }
    
    const answers = [];
    do{
      const answerParas = [];
      let hText;
      do{
        // console.log("456")
        i++;
        if(i >= allParas.length) break;
        hText = extractParagraphText(allParas[i]);
        // console.log({hText})
        if(hText && (hText.toLowerCase().trim() === ANSWER_TAG || hText.toLowerCase().trim() === QUESTION_TAG || hText.toLowerCase().trim() === CORRECT_ANSWER_TAG)){
          if(hText.toLowerCase().trim() === CORRECT_ANSWER_TAG){
            currentAnswerIndex = answers.length;
          }
          break;
        }

        answerParas.push(allParas[i]);

      }while(i < allParas.length); //for each annser paragraph
      answers.push(answerParas);
      // console.log("outside filling answer ", i)

      if(hText && hText.toLowerCase().trim() === QUESTION_TAG){
        i++;
        break;
      }
      

    }while(i < allParas.length); //for each answer





    // extractOrderedItemsFromXml(orderedSet, p);
    // 1) Block equations (m:oMathPara) inside this paragraph?
    // const oMathParas = q(p, M, "oMathPara");
    // if (oMathParas.length) {
    //   for (const m of oMathParas) {
    //     const omml = serialize(m);
    //     const mathml = omml2mathml(omml);
    //     const latex = MathMLToLaTeX.convert(mathml);
    //     rootChildren.push(makeEquationNode(latex, false));
    //   }
    //    continue; // treat this p as only math
    // }

    // 2) Images (block) — drawing -> a:blip r:embed -> rels -> word/media/*
    // const drawings = p.getElementsByTagNameNS("*", "drawing");
    // if (drawings.length) {
    //   for (const d of Array.from(drawings)) {
    //     const blips = d.getElementsByTagNameNS("*", "blip");
    //     for (const b of Array.from(blips)) {
    //       const rid = b.getAttributeNS(R, "embed");
    //       if (!rid) continue;
    //       const target = rels[rid]; // e.g. "media/image1.png"
    //       if (!target) continue;
    //       const path = target.startsWith("word/") || target.startsWith("/")
    //         ? target.replace(/^\//, "")
    //         : `word/${target}`;
    //       const img = zip.file(path);
    //       if (img) {
    //         const ab = await img.async("arraybuffer");
    //         const url = URL.createObjectURL(new Blob([ab]));
    //         rootChildren.push(makeImageNode(url, ""));
    //       }
    //     }
    //   }
    //   // also keep any text in the paragraph
    // }

    // 3) Normal paragraph content (text + inline math)
    // const paraKids = buildParagraphChildrenFromP(p);
    // if (paraKids.length) {
    //   rootChildren.push(makeParagraph(paraKids));
    // }
    const question = {
      questionParas,
      answers,
      currentAnswerIndex
    }
    allQuestions.push(question);
  }while (i < allParas.length);


  let j = 0;
  for(const q of allQuestions){
    for (const qq of q.questionParas) {
    convertToLatexCompatibleObject(qq)
    }
    break;
  }

  // Also pull images from headers if needed (optional)
  // const headers = Object.keys(zip.files).filter(p => p.startsWith("word/header") && p.endsWith(".xml"));
  // ...

  return makeRoot(rootChildren);
}

export function hasSubOrSup(documentXmlString) {
    const doc = new DOMParser().parseFromString(
      documentXmlString,
      "application/xml"
    );
    const nodes = Array.from(doc.getElementsByTagNameNS(W, "vertAlign"));
    return nodes.some((n) => {
      const val = n.getAttributeNS(W, "val");
      return val === "subscript" || val === "superscript";
    });
  }

  // ---------- Cell: paragraphs + nested tables ----------
function extractCell(tcEl) {
  const paragraphs = [];
  const tables = [];

  for (const child of Array.from(tcEl.childNodes)) {
    if (!isEl(child)) continue;

    // Direct paragraph in cell
    if (child.namespaceURI === W && child.localName === "p") {
      // paragraphs.push(paragraphToModel(child));
      paragraphs.push(child);
      continue;
    }
    // // Nested table
    // if (child.namespaceURI === W && child.localName === "tbl") {
    //   tables.push(tableToModel(child)); // recurse
    //   continue;
    // }
    // Some cells wrap content in <w:tc/w:tcPr> + <w:p> siblings; we ignore tcPr here
  }

  // Col/row spans if you need them:
  const tcPr = Array.from(tcEl.childNodes).find(
    (n) => isEl(n) && n.namespaceURI === W && n.localName === "tcPr"
  );
  let colspan = 1,
    rowspan = 1,
    vMerge = null;
  if (tcPr) {
    const gridSpan = tcPr.getElementsByTagNameNS(W, "gridSpan")[0];
    if (gridSpan)
      colspan = parseInt(gridSpan.getAttributeNS(W, "val") || "1", 10) || 1;
    const vM = tcPr.getElementsByTagNameNS(W, "vMerge")[0];
    if (vM) vMerge = vM.getAttributeNS(W, "val") || "continue"; // 'restart' | 'continue'
    // Computing rowspan requires scanning rows; we just expose vMerge flag here
  }

  return {
    paragraphs,
    tables,
    colspan,
    vMerge,
    rowspan /* to be computed if you want */,
  };
}

// ---------- Table model: rows -> cells (with cell content) ----------
function tableToModel(tblEl) {
  const rows = [];
  // only direct <w:tr> children
  for (const tr of Array.from(tblEl.childNodes).filter(n => isEl(n) && n.namespaceURI === W && n.localName === "tr")) {
    const row = [];
    // only direct <w:tc> children
    for (const tc of Array.from(tr.childNodes).filter(n => isEl(n) && n.namespaceURI === W && n.localName === "tc")) {
      row.push(extractCell(tc));
    }
    rows.push(row);
  }
  return { rows };
}

function extractTablesAndCells(doc) {
  // const doc = parseXml(documentXmlString);
  const tbls = Array.from(doc.getElementsByTagNameNS(W, "tbl"))
    .filter(t => t.parentNode && t.parentNode.namespaceURI === W); // avoid picking up nested twice
  return tbls.map(tableToModel);
}

export async function docxToQuestionsFromTable(file) {
  try {
    const zip = await JSZip.loadAsync(await file.arrayBuffer());
    const docXmlFile = zip.file("word/document.xml");
    if (!docXmlFile)
      throw new Error("word/document.xml not found (invalid DOCX?)");

    const docXml = parseXml(await docXmlFile.async("text"));

    const tables = extractTablesAndCells(docXml);
    console.log("Number of tables found: ", tables.length);

    const allQuestions = [];

    for (let ti = 0; ti < tables.length; ti++) {
      const table = tables[ti];
      const questionParas = [];
      const answers = [];
      const correctAnswerIndexArray = [];

      console.log(table);

      console.log(`Table ${ti} has ${table.rows.length} rows`);
      for (let ri = 0; ri < table.rows.length; ri++) {
        const row = table.rows[ri];
        console.log(` Row ${ri} has ${row.length} cells`);
        for (let ci = 0; ci < row.length; ci++) {
          const cell = row[ci];
          console.log(
            `  Cell ${ci} has ${cell.paragraphs.length} paragraphs and ${cell.tables.length} nested tables`
          );
          const cellParas = [];
          for (let pi = 0; pi < cell.paragraphs.length; pi++) {
            const para = cell.paragraphs[pi];
            const text = extractParagraphText(para);
            console.log(`   Paragraph ${pi}: "${text}"`);
            cellParas.push(para);
          }

          if (ri === 0 && ci === 0) {
            //first cell of first row is question
            questionParas.push(...cellParas);
          } else {
            if (ci === 0) {
              //first cell of other rows are answers
              answers.push(cellParas);
            } else if (ri === 0){
              //other cells of other rows are correct answers
              for (const para of cellParas) {
                const text = extractParagraphText(para);
                console.log(`   Correct Answer Paragraph: "${text}"`);
                if (text) {
                  //can be multiple correct answers separated by comma
                  for (const n of text.split(",")) {
                    console.log({ n });
                    if (!isNaN(n) && n > 0) {
                      correctAnswerIndexArray.push(n - 1);
                    }
                  }
                }
              }
            }else{
              for (const para of cellParas) {
                const text = extractParagraphText(para);
                console.log(`   Extra Answer Paragraph: "${text}"`);
                if (text) {
                  if (!isNaN(text) && text > 0) {
                    correctAnswerIndexArray.push(ri - 1);
                  }
                }
              }
            }
          }
        }
      }

      const question = {
        questionParas,
        answers,
        correctAnswerIndexArray,
      };
      allQuestions.push(question);
    }

      console.log(allQuestions);

      // return allQuestions;

      // // const hasSubSup = hasSubOrSup(await docXmlFile.async("text"));

      // const body = q(docXml.documentElement, W, "body")[0];

      // // ordered lists (document)

      // // Walk paragraphs in order; if you want tables later, handle w:tbl similarly.
      // const allParas = q(body, W, "p");
      // let i = 0;
      // //find first i with h1 text "QUESTION"
      // do {
      //   let hText = extractParagraphText(allParas[i++]);
      //   // const lowcase = hText.toUpperCase().trim();
      //   if (hText && hText.toUpperCase().trim() === QUESTION_TAG) {
      //     break;
      //   }
      // } while (i < allParas.length);

      // if (i >= allParas.length) {
      //   return [];
      // }

      // do {
      //   // const p = allParas[i];    //if so read till next paragraph wich contains text ANSWER with h2 heading style
      //   const questionParas = [];
      //   let currentParaText = extractParagraphText(allParas[i]);
      //   //readiing question paragraphs
      //   while (
      //     currentParaText.toUpperCase().trim() !== ANSWER_TAG &&
      //     currentParaText.toUpperCase().trim() !== CORRECT_ANSWER_TAG &&
      //     currentParaText.toUpperCase().trim() !== CORRECT_ANSWER_TAG_NUMBER
      //   ) {
      //     // console.log(currentParaText)
      //     questionParas.push(allParas[i]);
      //     i++;
      //     // console.log("inside filling question ", i)
      //     if (i >= allParas.length) break;
      //     currentParaText = extractParagraphText(allParas[i]);
      //   }

      //   const correctAnswerIndexArray = [];
      //   let currentAnswerIndex = -1;
      //   if (currentParaText.toUpperCase().trim() === CORRECT_ANSWER_TAG) {
      //     currentAnswerIndex = 0;
      //     correctAnswerIndexArray.push(0);
      //   }

      //   if (currentParaText.toUpperCase().trim() === CORRECT_ANSWER_TAG_NUMBER) {
      //     i++;
      //     // console.log("inside filling answer ", i)
      //     if (i >= allParas.length) break;
      //     const answerNumber = extractParagraphText(allParas[i]);
      //     console.log({ answerNumber });
      //     for (const n of answerNumber.split(",")) {
      //       const num = parseInt(n.trim());
      //       if (!isNaN(num) && num > 0) {
      //         correctAnswerIndexArray.push(num - 1);
      //       }
      //     }
      //     console.log(correctAnswerIndexArray);
      //   }

      //   const answers = [];
      //   do {
      //     const answerParas = [];
      //     let hText;
      //     do {
      //       i++;
      //       // console.log("inside filling answer ", i)
      //       if (i >= allParas.length) break;
      //       hText = extractParagraphText(allParas[i]);
      //       // console.log({hText})
      //       if (
      //         hText &&
      //         (hText.toUpperCase().trim() === ANSWER_TAG ||
      //           hText.toUpperCase().trim() === QUESTION_TAG ||
      //           hText.toUpperCase().trim() === CORRECT_ANSWER_TAG)
      //       ) {
      //         if (hText.toUpperCase().trim() === CORRECT_ANSWER_TAG) {
      //           currentAnswerIndex = answers.length + 1;
      //           correctAnswerIndexArray.push(currentAnswerIndex);
      //         }
      //         break;
      //       }

      //       answerParas.push(allParas[i]);
      //     } while (i < allParas.length); //for each annser paragraph
      //     answers.push(answerParas);
      //     // console.log("outside filling answer ", i)

      //     if (hText && hText.toUpperCase().trim() === QUESTION_TAG) {
      //       i++;
      //       break;
      //     }
      //   } while (i < allParas.length); //for each answer

      //   const question = {
      //     questionParas,
      //     answers,
      //     currentAnswerIndex,
      //     correctAnswerIndexArray,
      //   };
      //   allQuestions.push(question);
      // } while (i < allParas.length);

      return allQuestions;
  } catch (e) {
    console.log(e);
    return [];
  }
}
